export default {
  'notFound.title': '¡La página que estás buscando no existe!',
  'notFound.subtitle': 'Si tienes algún problema, ponte en contacto con el soporte de Btime'
}
